import React from 'react';

function Prestations() {
  return (
    <div>
      <h1>Prestations</h1>
      <p>Page à implémenter</p>
    </div>
  );
}

export default Prestations;
